import axios from "axios"
import constant from "@/service/constant"

const utils = {
  install(Vue) {
    Vue.prototype.$openLink = url => {
      window.open(url)
    }
    Vue.prototype.$appdownStore = () => {
      const wrap = document.querySelector("#wrap")
      const layerStore = document.querySelector(".layer_store")
      wrap.addEventListener("click", event => {
        if (event.target.closest(".playstore")) layerStore.classList.toggle("show_qr")
        else layerStore.classList.remove("show_qr")
      })
    }
    Vue.prototype.$changeDateFormat = format => {
      let year = format.getFullYear()
      let month = format.getMonth() + 1
      if (month < 10) month = "0" + month
      let date = format.getDate()
      if (date < 10) date = "0" + date
      return `${year}-${month}-${date}`
    }
    Vue.prototype.$guid = () => {
      function _p8(s) {
        let p = (Math.random().toString(16) + "000000000").substr(2, 8)
        return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p
      }
      return _p8() + _p8(true) + _p8(true) + _p8()
    }
    Vue.prototype.$SRSServer = httpData => {
      let hostServer = constant.MHRS_LIVE
      if (window.location.host.indexOf("dev") >= 0 || window.location.host.indexOf("local") >= 0) {
        hostServer = constant.MHRS_DEV
      } else if (window.location.host.indexOf("192.") >= 0) {
        hostServer = "http://192.168.30.15:2038"
      }

      return axios.post(hostServer, JSON.stringify(httpData))
    }
  },
}

export default utils
